var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404.11 897.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #003c52;\n        opacity: .4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.07,859.8c-19.48-54.42,20.17-116.34,48.24-158.29,28.07-41.96-25.18-99.13-71.94-138.16-46.76-39.04-52.48-112.58-14.38-181.45,38.1-68.87,19.77-161.94-58.44-207.72C173.35,128.38,52.22,106.62,0,0L156.05,897.97l192.02-38.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveTwo);
export default __webpack_public_path__ + "static/media/wave-two.5c23d2264d08fbe163aec3f6f6e00e00.svg";
export { ForwardRef as ReactComponent };